function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const getPaddingFromClassName = (className, type = 'mobile')=>{
    const BASE_PADDING = {
        mobile: {
            x: 20,
            left: 0,
            right: 0
        },
        tablet: {
            x: 20,
            left: 0,
            right: 0
        },
        desktop: {
            x: 36,
            left: 0,
            right: 0
        }
    };
    if (!className) {
        if (type === 'tablet') {
            const mobileValues = getPaddingFromClassName(className, 'mobile');
            return {
                x: mobileValues.x,
                left: mobileValues.left,
                right: mobileValues.right
            };
        }
        return BASE_PADDING[type];
    }
    const classes = className.split(' ');
    const prefix = type === 'mobile' ? '' : `${type}:`;
    // 현재 타입의 클래스가 없으면 이전 타입의 값을 사용
    const hasCurrentTypeClass = classes.some((cls)=>cls.startsWith(prefix + 'px-') || cls.startsWith(prefix + 'pl-') || cls.startsWith(prefix + 'pr-'));
    if (!hasCurrentTypeClass) {
        if (type === 'tablet') return getPaddingFromClassName(className, 'mobile');
    }
    const result = _object_spread({}, BASE_PADDING[type]);
    // px 처리
    const pxClass = classes.find((cls)=>cls === `${prefix}px-${result.x / 4}` || cls.startsWith(`${prefix}px-`));
    if (pxClass) {
        const value = Number(pxClass.replace(prefix, '').replace('px-', '')) * 4;
        result.x = value;
    }
    // pl 처리
    const plClass = classes.find((cls)=>cls.startsWith(`${prefix}pl-`));
    if (plClass) {
        const value = Number(plClass.replace(prefix, '').replace('pl-', '')) * 4;
        result.left = value;
    }
    // pr 처리
    const prClass = classes.find((cls)=>cls.startsWith(`${prefix}pr-`));
    if (prClass) {
        const value = Number(prClass.replace(prefix, '').replace('pr-', '')) * 4;
        result.right = value;
    }
    return result;
};
const calculateScrollbarWidth = ()=>{
    if (typeof window === 'undefined') return 0;
    const hasScrollbar = window.innerHeight < document.documentElement.scrollHeight;
    if (!hasScrollbar) {
        return 0;
    }
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    return scrollbarWidth;
};

export { calculateScrollbarWidth, getPaddingFromClassName };
